import { Component, PureComponent, Fragment } from 'react'
import _ from 'lodash'

import cx from 'classnames'
import styles from './index.css'
import { When, RadioGroupInputField, RadioGroup } from '../../../../../Common/Form'
import { Button, Tip } from '@vzmi/shp_shared_compo'
import AttributeTableField from './AttributeTable'
import SpecMenuSelectorField from './SpecMenuSelector'
import { Field, FormSection, FieldArray } from '../../../../../Common/forms'
import { required } from '../../../../../../lib/FormHelper'
import withAttributeTransient from '../../../../Common/HOC/withAttributeTransient'
import withProposalListingFormReadOnly from '../../../../Common/HOC/withProposalListingFormReadOnly'
import {
  getSlicedSpecItems,
  determineSpecLevel,
  getAttrTableFieldPrefixByLevel,
  convertRawDataToRenderingData,
  convertClusterToAttributeOption,
  convertAttributeItemOptions,
  getClusterAttributes
} from '../../../../Common/ProposalForm/Shared/util'
import { getUuid } from '../../../../../../../lib/renderUtil'
import { PRODUCT_SHIP_TYPE, PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'

const SELECTED_ITEM_OPTIONS_KEY = 'selectedItemOptions'
const getSpecFieldNormalizer = (fieldsLength, level) => value => {
  const selectedItemOptions = _.get(value, SELECTED_ITEM_OPTIONS_KEY, [])
  if (fieldsLength > 0) {
    _.set(
      value,
      SELECTED_ITEM_OPTIONS_KEY,
      getSlicedSpecItems(selectedItemOptions, fieldsLength, level)
    )
  }
  return value
}

class SpecMenuSelectorArrayField extends PureComponent {
  componentDidMount () {
    const { fields } = this.props

    if (fields.length === 0) {
      this.addAttributeLayer()
    }
  }

  getFilterAttributeList = ({ specLength, specData, level, fields }) => {
    const filterAttrValueList = []
    if (specLength === 2) {
      const filterLayerData = level === 1 ? fields.get(1) : fields.get(0)
      const currentSpecAttrOptVal = _.get(specData, 'selectedOption.value', null)
      const filterAttrVal = _.get(filterLayerData, 'selectedOption.value', null)
      const isDifferentAttrVal = currentSpecAttrOptVal !== filterAttrVal
      if (filterAttrVal && isDifferentAttrVal) {
        filterAttrValueList.push(filterAttrVal)
      }
    }
    return filterAttrValueList
  }

  getFilteredAttributeOptions = _.memoize((attrClusterAttributes, filterAttrValueList) => {
    const filterAttrValueSet = new Set(filterAttrValueList)
    if (filterAttrValueSet.size) {
      attrClusterAttributes = _.filter(attrClusterAttributes, o => !filterAttrValueSet.has(o.name))
    }
    return attrClusterAttributes.map(c => {
      return convertClusterToAttributeOption(c)
    })
  }, (...args) => getUuid(args))

  getAttributeItemOptionsByCluster = _.memoize((attrClusterAttributes, selectedOption) => {
    const filterAttrVal = _.get(selectedOption, 'value')
    const cluster = _.find(attrClusterAttributes, { name: filterAttrVal })
    if (cluster) {
      return convertAttributeItemOptions({ cluster })
    }
    return []
  }, (...args) => getUuid(args))

  getAttributeOptions = ({ specLength, specData, level, fields }) => {
    const { struDataAttrCluster } = this.props
    const attrClusterAttributes = getClusterAttributes(struDataAttrCluster)
    return this.getFilteredAttributeOptions(attrClusterAttributes, this.getFilterAttributeList({ specLength, specData, level, fields }))
  }

  getAttributeItemOptions = (selectedOption) => {
    const { struDataAttrCluster } = this.props
    const attrClusterAttributes = getClusterAttributes(struDataAttrCluster)
    return this.getAttributeItemOptionsByCluster(attrClusterAttributes, selectedOption)
  }

  addAttributeLayer = () => {
    const { fields } = this.props
    fields.push({ })
  }

  renderSpecFields = () => {
    const {
      fields,
      triggerFieldChange,
      syncTransientAttributes,
      struDataAttrCluster,
      hasSpecError,
      readOnly,
      proposalType
    } = this.props
    const fieldsLength = fields.length

    return fields.map((specFieldName, index) => {
      // specFieldName will be `__transient__.attribute.subxx_xxxxx.spec[0]`
      const specData = fields.get(index)
      const level = index + 1
      const isDisabledAddAttrBtn = _.isEmpty(specData.selectedOption) ||
        _.isEmpty(specData.selectedItemOptions) ||
        hasSpecError

      const hasAddAttrBtn = !readOnly &&
        level === 1 &&
        fieldsLength === 1

      return (
        <Fragment key={specFieldName}>
          <Field
            name={specFieldName}
            specData={specData}
            specIndex={index}
            specLength={fieldsLength}
            fields={fields}
            level={level}
            getAttributeOptions={this.getAttributeOptions}
            getAttributeItemOptions={this.getAttributeItemOptions}
            syncTransientAttributes={syncTransientAttributes}
            triggerFieldChange={triggerFieldChange}
            struDataAttrCluster={struDataAttrCluster}
            readOnly={readOnly}
            proposalType={proposalType}
            component={SpecMenuSelectorField}
            normalizeOnBlur={getSpecFieldNormalizer(fieldsLength, level)}
          />
          <When
            value={hasAddAttrBtn}
            isTrue
          >
            <Button
              data-role='add-attribute-button'
              disabled={isDisabledAddAttrBtn}
              link
              size='medium'
              iconType='add-attachments'
              className={styles.linkButton}
              onClick={this.addAttributeLayer}
            >
              增加屬性
            </Button>

          </When>
        </Fragment>
      )
    })
  }

  render () {
    return (
      <div
        className={styles.SpecMenuSelectorArrayField}
      >
        {this.renderSpecFields()}
      </div>
    )
  }
}

/**
 * 預設 value 為 false 且 readOnly 的 RadioGroup component
 */
const DefaultFalsyRadioGroup = props => {
  const {
    options,
    className
  } = props

  return (
    <RadioGroup
      disabled
      buttonStyle='outline'
      key='defaultFalsyRadioGroup'
      data-role='default-falsy-radio-group'
      defaultValue={false}
      className={className}
      options={options}
    />
  )
}

const getIsEVoucher = shipTypeId => shipTypeId === PRODUCT_SHIP_TYPE.E_VOUCHER

class AttributeSpecField extends Component {
  componentWillReceiveProps (nextProps) {
    // 確認 transientFieldReady，避免組出錯誤的 transientField 欄位
    const propsIsChanging = !_.isEqual(this.props, nextProps)
    const nextTransientFieldIsReady = _.get(nextProps, 'transientFieldReady', false)

    if (nextTransientFieldIsReady && propsIsChanging) {
      let transientModel = _.get(nextProps, 'transientModel', {})
      if (
        (
          // 從其他配送方式改成電子票券，商品屬性會是有/無屬性其一
          transientModel.hasSpecLevel ||
          // 規格表選擇近期使用會重置商品屬性成未選擇
          _.isUndefined(transientModel.hasSpecLevel)
        ) && getIsEVoucher(nextProps.shipTypeId)
      ) {
        // 電子票券強制轉換商品屬性欄位成無屬性賣場
        nextProps.triggerFieldChange(`${nextProps.transientField}.hasSpecLevel`, false)
        // 重新產生屬性表格時先把商品屬性寫成無屬性
        // 因為 redux form 是非同步寫入 state
        // 避免產生 table 時拿到的 hasSpecLevel 還沒更新所以先手動更新
        transientModel = {
          ...transientModel,
          hasSpecLevel: false
        }
      }
      this.prepareAttrTable(
        {
          ...nextProps,
          transientModel
        }
      )
    }
  }

  /** reorder the table data on spec or specLevel changes */
  prepareAttrTable = nextProps => {
    const {
      transientField,
      transientModel: nextTransientModel,
      transientFieldReady: nextTransientFieldReady,
      struDataAttrCluster: nextStruDataAttrCluster,
      isClusterNotFound
    } = nextProps

    const {
      hasSpecLevel: nextHasSpecLevel,
      spec: nextSpec
    } = nextTransientModel

    const spec = this.props.transientModel.spec
    const hasSpecLevel = this.props.transientModel.hasSpecLevel
    let rawProduct = null
    let data = null

    const specIsChanging = !_.isEqual(spec, nextSpec)
    const specLevelIsChanging = !_.isEqual(hasSpecLevel, nextHasSpecLevel)

    if (
      specIsChanging ||
      specLevelIsChanging ||
      !_.isEqual(this.props.transientFieldReady, nextTransientFieldReady) ||
      !_.isEqual(this.props.struDataAttrCluster, nextStruDataAttrCluster)
    ) {
      // sync the transient attributes
      this.props.syncTransientAttributes(transientField, nextTransientModel, nextStruDataAttrCluster)
    }

    if (!isClusterNotFound && specIsChanging) {
      rawProduct = _.get(nextTransientModel, `${getAttrTableFieldPrefixByLevel(hasSpecLevel)}`, {})

      // if spec layer added up to 2 layers, then reset the table data
      const specLayerIsChanging = _.size(spec) === 2 && _.size(nextSpec) === 1
      if (specLayerIsChanging) {
        rawProduct = {}
      }

      data = nextTransientModel
    }

    if (_.isEqual(this.props.transientField, transientField)) {
      if (specLevelIsChanging && nextHasSpecLevel === false) {
        const defaultData = {
          product: {
            models: [{
              items: [{ stock: 0 }]
            }]
          }
        }
        data = defaultData
        rawProduct = _.get(nextTransientModel, `${getAttrTableFieldPrefixByLevel(nextHasSpecLevel)}`, {})
      }
    } else {
      rawProduct = _.get(nextTransientModel, `${getAttrTableFieldPrefixByLevel(nextHasSpecLevel)}`, {})
      data = nextTransientModel
    }

    if (rawProduct && data) {
      // convert spec options to raw data for table to render
      const rawData = convertRawDataToRenderingData({ rawProduct, data, hasSpecLevel: nextHasSpecLevel })
      this.props.triggerFieldChange(`${transientField}.${getAttrTableFieldPrefixByLevel(nextHasSpecLevel)}`, rawData)
      if (isClusterNotFound) {
        // 如果規格表查不到的時候，開放使用者重新選擇規格表，但是商品屬性會保持原先設定且不能修改
        this.props.triggerFieldChange(`${transientField}.spec`, spec)
        this.props.triggerFieldChange(`${transientField}.hasSpecLevel`, hasSpecLevel)
      }
    }
  }

  render () {
    const props = this.props
    const {
      proposalType,
      productName,
      className,
      shipTypeId: originShipTypeId,
      syncTransientAttributes,
      triggerFieldChange,
      transientFieldReady,
      transientField,
      transientModel,
      transientErrors,
      struDataAttrCluster,
      readOnly,
      showExpiringAddon,
      meta,
      showErrorOnActive,
      mustShowFormError
    } = props
    const { hasSpecLevel } = transientModel
    const {
      withSpecLevel
      // withoutSpecLevel,
      // specLevelUndefined
    } = determineSpecLevel(hasSpecLevel)
    const shipTypeId = +originShipTypeId

    const hasSpecError = withSpecLevel && _.get(transientErrors, 'spec.length', 0) >= 1

    const isUpdateAttribute = proposalType === PROPOSAL_TYPE.UPDATE_ATTRIBUTE
    const isDisabledEditSpec = (
      isUpdateAttribute ||
      readOnly ||
      !transientFieldReady
    )
    // 新增提案商品、未選取商品選項、檢視確認頁時顯示上傳圖片提示
    const isUploadImageTipVisible = (
      (
        proposalType === PROPOSAL_TYPE.NEW_LISTING ||
        proposalType === PROPOSAL_TYPE.NEW_PRODUCT
      ) &&
      _.isUndefined(hasSpecLevel) &&
      !readOnly
    )

    return (
      <FormSection name={transientField}>
        <div
          className={cx(styles.AttributeSpecSelector, className)}
          data-role='attribute-spec-selector'
          ref={r => (this.productAttribute = r)}
        >
          <Field
            name='hasSpecLevel'
            data-role='with-spec-level-radio'
            className={styles.withSpecLevelRadio}
            disabled={isDisabledEditSpec || getIsEVoucher(shipTypeId)}
            validate={
              transientFieldReady
                ? required({ msg: '請選擇商品選項' })
                : null
            }
            component={
              transientFieldReady
                ? RadioGroupInputField
                : DefaultFalsyRadioGroup
            }
            options={[
              { label: '無選項', value: false },
              { label: '有選項', value: true }
            ]}
            showErrorOnActive={showErrorOnActive}
            mustShowFormError={mustShowFormError}
          />
          {
            isUploadImageTipVisible && (
              <Tip className={styles.uploadImgTip}>
                選擇規格表並確認商品屬性後，方能進行圖片上傳。
              </Tip>
            )}
          <When
            value={withSpecLevel}
            isTrue
          >
            <FieldArray
              name='spec'
              transientErrors={transientErrors}
              hasSpecError={hasSpecError}
              triggerFieldChange={triggerFieldChange}
              struDataAttrCluster={struDataAttrCluster}
              syncTransientAttributes={syncTransientAttributes}
              readOnly={isUpdateAttribute || readOnly}
              proposalType={proposalType}
              component={SpecMenuSelectorArrayField}
              showErrorOnActive={showErrorOnActive}
              mustShowFormError={mustShowFormError}
            />
          </When>
          <When
            value={!hasSpecError && !isUpdateAttribute}
            isTrue
          >
            <AttributeTableField
              triggerFieldChange={triggerFieldChange}
              transientField={transientField}
              transientModel={transientModel}
              shipTypeId={shipTypeId}
              proposalType={proposalType}
              productName={productName}
              showExpiringAddon={showExpiringAddon}
              meta={meta}
              showErrorOnActive={showErrorOnActive}
              mustShowFormError={mustShowFormError}
            />
          </When>

        </div>
      </FormSection>
    )
  }
}

const hoc = _.flow([
  withAttributeTransient,
  withProposalListingFormReadOnly
])

export default hoc(AttributeSpecField)
